import { render, staticRenderFns } from "./VendorRegister-1.vue?vue&type=template&id=6a1ca73a"
import script from "./VendorRegister-1.vue?vue&type=script&lang=js"
export * from "./VendorRegister-1.vue?vue&type=script&lang=js"
import style0 from "./VendorRegister-1.vue?vue&type=style&index=0&id=6a1ca73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports